import { render, staticRenderFns } from "./GalleryFrame.vue?vue&type=template&id=0817521a&"
import script from "./GalleryFrame.vue?vue&type=script&lang=js&"
export * from "./GalleryFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ImageComponent/index.vue').default})
